<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding-left: 10px;padding-top: 10px;">
          <!-- <div style="margin: 5px;margin-bottom: 10px;cursor:pointer;">
            <el-carousel height="55px" indicator-position="none" direction="vertical" interval="3000">

              <el-carousel-item style="display: flex;justify-content: center;">
                <div @click="showWanSearchDialog()">
                  <h2 style="margin-left: 10px;align-items: center;">
                    发放分班、发放工资条用<span style="color:red;">万能快查小程序</span>，查询条件可任意设置，点我了解.</h2>
                </div>
              </el-carousel-item>

              <el-carousel-item style="display: flex;justify-content: center;">
                <div @click="showCheckingDialog()">
                  <h2 style="margin-left: 10px;align-items: center;">
                    核对学籍资料,核对学生资料,用<span style="color:red;">核对信息小程序</span>,核对完的数据一键导出excel,点我了解.</h2>
                </div>
              </el-carousel-item>

              <el-carousel-item style="display: flex;justify-content: center;">
                <div @click="showShareDocDialog()">
                  <h2 style="margin-left: 10px;align-items: center;">
                    收集学籍,照片等资料用<span style="color:red;">多人填表小程序</span>收集,保护隐私简单易用,一键导出excel,点我了解.</h2>
                </div>
              </el-carousel-item>


              <el-carousel-item style="display: flex;justify-content: center;">
                <div @click="showEvaluationsDialog()">
                  <h2 style="margin-left: 10px;align-items: center;">
                    师风评价、互评自评用<span style="color:red;">打分测评小程序</span>,保护隐私自动汇总,一键导出excel,点我了解.</h2>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div> -->
          <div>
            <el-row style="display: flex;justify-content: space-evenly;">
              <el-tooltip class="item" effect="dark" content="导入成绩后下一步该怎么办？" placement="bottom">
                <el-button type="danger" round @click="importedNextStep">成绩导完后告诉大家怎么查</el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="可以解锁掉所有已经锁定的手机端,请谨慎操作." placement="bottom">
                <el-button type="primary" round @click="unlockAllPhone">解锁所有手机</el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="手机端只能查一人成绩,查了别人的就不能查自己的,要解除锁定用这个,解除锁定后还是只能查一个人的成绩."
                placement="bottom">
                <el-button type="primary" round @click="unlockPhone">解锁单部手机</el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="打开或者关闭查询结果内容,对所有发布的成绩都有效!" placement="bottom">
                <el-button type="primary" round @click="phoneShowSetting">设置手机查询显示结果</el-button>
              </el-tooltip>
            </el-row>
          </div>
        </div>

        <div style="padding-left: 10px;padding-top: 5px;padding-right: 5px;">
          <el-table border :data="tableData" stripe style="width: 100%;"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
            <el-table-column type="index" label="序号" width="50" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="exam" label="考试名称">
            </el-table-column>

            <el-table-column prop="courseCount" label="科目数" width="70">
            </el-table-column>

            <el-table-column prop="grade" label="年级" width="80">
            </el-table-column>
            <el-table-column prop="total" label="总数(人)" width="80" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="actionStyle" v-if="scope.row.total==0">
                  <span @click="showZeroHelp(scope.row.exam)"
                    style="color: red;font-size: 20px;font-weight: bold;cursor: pointer;">{{scope.row.total}}<i
                      class="el-icon-question" /></span>
                </div>
                <div class="actionStyle" v-else>
                  <span>{{scope.row.total}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="searchedTotal" label="已查(人)" width="80" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="unReadTotal" label="未查(人)" width="80" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="searchedPercent" label="查询率(%)" width="90" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="pub_time" label="发布时间" width="100" header-align="center" align="center">
            </el-table-column>
            <el-table-column label="查询状态" header-align="center" align="center" width="120">
              <template slot-scope="scope">
                <div>
                  <div v-if="scope.row.search_state==1" style="color:green">查询开放中</div>
                  <div v-if="scope.row.search_state==0" style="color:red">
                    {{getStopSearchLabel(scope.row.search_state,scope.row.search_start_time)}}
                  </div>
                  <div style="margin-top: 10px;text-decoration: underline;font-weight: bold;color:red;"
                    v-if="scope.row.search_state=='0'"
                    @click="viewDetailReason(scope.row.search_state,scope.row.search_start_time)">查看详情</div>
                  <div style="margin-top: 10px;text-decoration: underline;font-weight: bold;color:red;cursor:pointer;"
                    @click="testQueryDialogVisible=true">点我试查</div>

                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="关闭原因" header-align="center" align="center" width="150">
              <template slot-scope="scope">
                <div @click="testQueryDialogVisible=true">
                  <div v-if="scope.row.search_state=='1'"></div>
                  <div v-if="scope.row.search_state=='0'">
                    <div>
                      <div v-if="scope.row.search_start_time==''" style="color:green">手工关闭</div>
                      <div v-else style="color:red">未到开放时间<br/>({{scope.row.search_start_time}}).</div>
                    </div>

                  </div>

                </div>
              </template>
            </el-table-column> -->
            <el-table-column label="操作" header-align="center" align="center" width="200">
              <template slot-scope="scope">
                <div class="actionStyle">
                  <div>
                    <el-button @click.native.prevent="importedNextStep" type="text" size="small">
                      发布成绩单
                    </el-button>
                  </div>

                  <div>
                    <el-button @click.native.prevent="viewExam(scope.$index, tableData)" type="text" size="small">
                      查看成绩单
                    </el-button>
                  </div>


                  <div>
                    <el-button @click.native.prevent="editExam(scope.$index, tableData)" type="text" size="small">
                      修改考试信息
                    </el-button>
                  </div>

                  <div>
                    <el-button @click.native.prevent="publishNotice(scope.$index, tableData)" type="text" size="small">
                      添加成绩单通知
                    </el-button>
                  </div>

                  <div>
                    <el-button @click.native.prevent="openExamReport(scope.$index, tableData)" type="text" size="small">
                      考试分析报告
                    </el-button>
                  </div>

                  <div>
                    <el-button @click.native.prevent="delExam(scope.$index, tableData)" type="text" size="small">
                      删除成绩单
                    </el-button>
                  </div>
                  <div>
                    <el-button @click.native.prevent="pointSetting(scope.$index, tableData)" type="text" size="small">
                      设置小数点位数
                    </el-button>
                  </div>
                  <div>
                    <el-button @click.native.prevent="exportStudentNumList(scope.$index, tableData)" type="text"
                      size="small">
                      导出姓名学号对应表
                    </el-button>
                  </div>
                  <div>
                    <el-button @click.native.prevent="viewUnSearchList(scope.$index, tableData)" type="text"
                      size="small">
                      查看未查成绩名单
                    </el-button>
                  </div>

                  <div>
                    <el-button @click.native.prevent="setSearchTime(scope.$index, tableData)" type="text" size="small">
                      <span>设置查询开放时间</span>
                    </el-button>
                  </div>
                  <div>
                    <el-button @click.native.prevent="setSearchState(scope.$index, tableData,scope.row.search_state)"
                      type="text" size="small">

                      <div v-if="scope.row.search_state==1">关闭查询</div>
                      <div v-if="scope.row.search_state==0">打开查询</div>
                    </el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center;">
          <div style="text-align: center;"><span style="font-size: 14px;">手机端微信或QQ"快查成绩"小程序"录入成绩"界面中也可查看查询情况和管理成绩</span>
          </div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            layout="total, prev, pager, next" :total="total_record" :page-size="pageSize">
          </el-pagination>

        </div>
      </el-col>
    </el-row>

    <el-dialog title="重要提示" :visible.sync="dialogVisible" width="30%">
      <span>{{msg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="delExamRecord">删 除</el-button>
      </span>
    </el-dialog>

    <el-dialog title="手机端成绩查询结果显示设置" width="30%" :visible.sync="searchResultSettingDialogTableVisible">
      <div>
        <div class="settingGroupStyle">
          <div style="margin-bottom: 10px;margin-left: 10px;">
            <el-checkbox v-model="showScoreAvg">显示平均成绩</el-checkbox>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <el-checkbox v-model="showSection">显示成绩分段分析图</el-checkbox>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <el-checkbox v-model="showAvgTrend">显示平均分对比趋势</el-checkbox>
          </div>

        </div>

        <div class="rowBtnStyle">

          <span>
            <el-button @click="closeSettings">取消</el-button>
            <el-button type="primary" @click="saveSettings">保存</el-button>
          </span>

        </div>

      </div>
    </el-dialog>

    <!--修改查询状态-->
    <el-dialog :title="setSearchStateDialogTitle" :visible.sync="setSearchStatedialogVisible" width="30%">
      <span>当前状态时:{{setSearchStateInfo}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setSearchStatedialogVisible = false">取消</el-button>
        <el-button type="primary" @click="updateSearchState">{{setSearchStateBtn}}</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" v-dialogDrag title="未查成绩学生名单" :visible.sync="unReadDialogFormVisible">
      <el-form>
        <div>
          <div>
            <el-table :data="students" height="200" style="width: 100%"
              :header-cell-style="{background:'#eef1f6',color:'#606266'}">
              <el-table-column prop="student_name" label="姓名">
              </el-table-column>
              <el-table-column prop="student_num" label="学号">
              </el-table-column>
            </el-table>
          </div>

        </div>

      </el-form>
      <div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeUnreadDialog">关 闭</el-button>
      </div>
    </el-dialog>

    <!--成绩导入成功提示-->
    <el-dialog width="80%" :close-on-click-modal="false" title='发布查询就是转发小程序并告知怎么查' :visible.sync="successDialogVisible">
      <!-- <el-form-item label="卷面分"> -->
      <div class="colStyle">
        <div style="font-size: 16px;">
          <span
            style="font-weight: bold;">第一步:转发。转发快查成绩小程序或二维码(效果一样)。</span>要让大家能查询到，需要将“快查成绩”小程序分享到群里,手机扫下面的码打开小程序,要分享到微信群扫左侧的,QQ群扫右侧的。
        </div>
        <div class="imageStyle">
          <div class="imgItemStyle" style="padding-right: 10px;"><img
              src="https://www.sales1.top/score/images/weixin.jpg" width="150px;" />
            <div>微信群分享扫这个</div>
          </div>
          <div class="imgItemStyle" style="padding-left: 10px;"><img src="https://www.sales1.top/score/images/QQ.png"
              width="150px;" />
            <div>QQ群分享扫这个</div>
          </div>
        </div>

        <div style="padding-top: 10px;width:100%;">
          扫码后会打开小程序,小程序右上角点<font color="red">"转发"</font>转发到群里即可完成小程序转发操作。
        </div>


        <div style="padding-top: 10px;font-size: 16px;">
          <span
            style="font-weight: bold;">第二步：告知。转发学生姓名和学号对应表或告知输入什么内容可查询到成绩。</span>打开手机端“快查成绩”小程序，登录后并点开您刚导入的成绩单，点击“导出学号”可以导出姓名和学号对应的Excel表格，然后把表格分享到家长群中即可。
        </div>
        <div style="color: red;margin-top: 20px;">
          注意：1个手机只能查1个人的成绩,查询成功后会锁定在第一次查询的学生上。为了避免学生利用公开的姓名和学号对应关系解锁后查询别人的成绩，请将学号私发给学生和家长，并让其保密。</div>
        <!--        <div>
          <div class="imgItemStyle">
            <el-image style="width: 100px; height: 100px" :src="qrcode_img_url" :fit="fit"></el-image>
            <div>扫这个码下载姓名学号对应表</div>
            <div style="color: red;">如果看不到二维码刷新页面后再试</div>
          </div>
        </div> -->

        <!-- </div> -->
      </div>

      <!-- </el-form-item> -->

      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="cacelSetPaperScore">取 消</el-button> -->
        <el-button type="primary" @click="successDialogVisible=false">我知道了</el-button>
      </div>
    </el-dialog>

    <el-dialog title="解锁单部手机" :visible.sync="unlockDialogVisible" width="30%">
      <div style="padding-bottom: 10px;"><span>请输入被锁定的学生姓名和学号:</span></div>
      <div>
        <el-form ref="unlockForm" :model="unlockForm" label-width="40px" size="mini">
          <el-form-item label="姓名">
            <el-input v-model="unlockForm.student_name" placeholder="输入学生的姓名"></el-input>
          </el-form-item>
          <el-form-item label="学号">
            <el-input v-model="unlockForm.student_num" placeholder="输入学生的学号"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="unlockDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="unlock">解锁</el-button>
      </span>
    </el-dialog>

    <!--多人填表广告-->
    <el-dialog title="多人填表就用多人填表,简单易用,保护隐私,一键导出!" width="50%" :visible.sync="shareDocDialogVisible">
      <div>
        <div style="font-size: 16px;">
          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">好处一.家长填写简单,按照您要求填写,不会错，身份证、手机号等等错了很麻烦。</span>
            </div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">好处二.保护隐私，互相无法查看。用接龙、共享文档大家都能互相看，甚至会改了别人的资料，纠正麻烦。</span></div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">好处三.一键导出excel。文字、图片等都给您导入到excel里，基本上不用加工就可以直接上交了，省时省力，告别复制粘贴.</span>
            </div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div>
              <div style="font-size: 16px;margin-top: 10px;margin-bottom: 20px;text-align: center;">
                <div style="font-weight: bold;color:red;">立即用微信扫码体验</div>
                <div><img src="/score/images/duoren_mp.jpg" style="width: 200px;height: 200px;" /></div>
                <div style="font-weight: bold;">多人填表用多人填表</div>
                <div style="font-weight: bold;">拒绝泄露个人隐私,只因您也是家长！</div>
              </div>
            </div>
          </div>
        </div>

        <div class="rowBtnStyle">

          <span>
            <el-button type="primary" @click="shareDocDialogVisible=false">我知道了</el-button>
          </span>

        </div>

      </div>
    </el-dialog>


    <!--万能快查广告-->
    <el-dialog title="发分班,发工资条,1分钟构建查询系统!" width="50%" :visible.sync="wansearchDialogVisible">
      <div>
        <div style="font-size: 16px;">
          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">万能快查小程序-可以任意设置查询条件的查询系统！</span>
            </div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">特点1.可以任意设置查询条件；</span></div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">特点2.支持任意Excel文件导入；</span></div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">特点3.谁查谁没查一目了然。</span></div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div>
              <div style="font-size: 16px;margin-top: 10px;margin-bottom: 20px;text-align: center;">
                <div style="font-weight: bold;color:red;">立即用微信扫码体验</div>
                <div><img src="/score/images/wnkc_qrcode.jpg" style="width: 200px;height: 200px;" /></div>
                <div style="font-weight: bold;">万能快查，发啥查啥！</div>
              </div>
            </div>
          </div>
        </div>

        <div class="rowBtnStyle">

          <span>
            <el-button type="primary" @click="wansearchDialogVisible=false">我知道了</el-button>
          </span>

        </div>

      </div>
    </el-dialog>


    <!--核对信息广告-->
    <el-dialog title="核对学籍,补填资料,一键导出Excel用核对信息小程序!" width="50%" :visible.sync="checkingDialogVisible">
      <div>
        <div style="font-size: 16px;">
          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">核对信息小程序-核对资料、补填资料专用工具！</span>
            </div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">特点1.可以任意设置查询条件；</span></div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">特点2.支持任意Excel文件导入；</span></div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">特点3.核对、补填完的数据一键导出Excel文件。</span></div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div>
              <div style="font-size: 16px;margin-top: 10px;margin-bottom: 20px;text-align: center;">
                <div style="font-weight: bold;color:red;">立即用微信扫码体验</div>
                <div><img src="/score/images/hdxx_qrcode.jpg" style="width: 200px;height: 200px;" /></div>
                <div style="font-weight: bold;">核对信息-省时省力</div>
              </div>
            </div>
          </div>
        </div>

        <div class="rowBtnStyle">

          <span>
            <el-button type="primary" @click="checkingDialogVisible=false">我知道了</el-button>
          </span>

        </div>

      </div>
    </el-dialog>


    <!--核对信息广告-->
    <el-dialog title="师风评价,考核打分用打分测评小程序!" width="50%" :visible.sync="evaluationsDialogVisible">
      <div>
        <div style="font-size: 16px;">
          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">打分测评小程序-绩效考核、师风评价、互评自评！</span>
            </div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">特点1.保护隐私；</span></div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">特点2.自动汇总；</span></div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">特点3.打分结果一键导出Excel文件。</span></div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div>
              <div style="font-size: 16px;margin-top: 10px;margin-bottom: 20px;text-align: center;">
                <div style="font-weight: bold;color:red;">立即用微信扫码体验</div>
                <div><img src="/score/images/dfcp_qrcode.jpg" style="width: 200px;height: 200px;" /></div>
                <div style="font-weight: bold;">打分测评-自动汇总</div>
              </div>
            </div>
          </div>
        </div>

        <div class="rowBtnStyle">

          <span>
            <el-button type="primary" @click="evaluationsDialogVisible=false">我知道了</el-button>
          </span>

        </div>

      </div>
    </el-dialog>

    <!--家长意见收集-->
    <el-dialog title="收集本次考试家长评语" width="50%" :visible.sync="collectAdviceDialogVisible">
      <div>
        <div style="font-size: 16px;">
          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div>成绩发布后,纸质统计不便、共享文档又操作不方便,对于老年人就难上加难，且家长之间可以互相查看泄露隐私,怎样收集家长反馈意见最省事？
            </div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div>请按以下步骤操作，可以轻松收集到家长评语：</div>
          </div>

          <div style="margin-bottom: 10px;margin-left: 10px;margin-bottom:10px;">
            <div><span style="font-weight: bold;">第一步：</span>打开<span
                style="font-weight: bold;">多人填表</span>小程序。微信搜索小程序“多人填表”或扫码下面的二维码打开“多人填表”；</div>
          </div>
          <div style="margin-bottom: 10px;margin-left: 10px;margin-bottom: 10px;">
            <div><span style="font-weight: bold;">第二步：</span>制作《考试家长评语收集表》。在“表格模板”中选入或者按照自己的需要制作表格；</div>
          </div>
          <div style="margin-bottom: 10px;margin-left: 10px;margin-bottom: 10px;">
            <div><span style="font-weight: bold;">第三步：</span>发放表格并填写。在家长群中发放表格，家长填写互相都看不见，且单行填写不至于看不清楚；</div>
          </div>
          <div style="margin-bottom: 10px;margin-left: 10px;margin-bottom: 10px;">
            <div><span style="font-weight: bold;">第四步：</span>导出excel格式反馈表。一键导出，省时省力。</div>
          </div>
          <div style="text-align: center;"><img src="/score/images/duoren_mp.jpg" style="width: 200px;height: 200px;" />
            <div>微信扫码打开“多人填表”</div>
          </div>
        </div>

        <div class="rowBtnStyle">
          <span>
            <el-button type="primary" @click="collectAdviceDialogVisible=false">我知道了</el-button>
          </span>

        </div>

      </div>
    </el-dialog>



    <!--危害提示-->
    <el-dialog title="查看原因" width="40%" :visible.sync="zeroHelpDialogVisible">
      <div>
        <div style="font-size: 16px;">
          <div style="margin-bottom: 10px;margin-left: 10px;">
            <div><span style="font-weight: bold;">《{{selectedZeroExam}}》中没有数据,如果是导入后没有数据，请扫描下面二维码入群寻求客服帮助。</span>
            </div>
          </div>
          <div>
            <div style="text-align: center;">
              <img src="/score/images/kc_teacher_group.png" style="width:300px;height:300px;" />

            </div>
          </div>


        </div>

        <div class="rowBtnStyle">

          <span>
            <el-button type="primary" @click="zeroHelpDialogVisible=false">我知道了</el-button>
          </span>

        </div>

      </div>
    </el-dialog>


    <el-dialog title="试着查一下查询是否正常" :visible.sync="testQueryDialogVisible" width="40%">
      <div>
        <div style="padding-bottom: 10px;">
          <span style="font-weight: bold;">试查不会影响家长查询,请放心试查。试查无误后将小程序或二维码转给家长即可查询。</span>
        </div>
        <div>
          <span style="font-weight: bold;">1.微信扫码打开查询小程序,输入查询条件查询;</span>
        </div>
        <div style="display: flex;justify-content: center;flex-direction: column;">
          <div>
            <img src="https://www.sales1.top/score/images/weixin.jpg" width="150px;" />
          </div>
          <div style="font-size: 12px;">在二维码上右键点“图片另存为”可保存二维码</div>
        </div>
        <div style="margin-top: 10px;">
          <span style="font-weight: bold;">2.能正常查询后将小程序(或上面的二维码)转发给家长或学生即可。</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="testQueryDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导出姓名学号对应表" :visible.sync="exportStudentNumListDialogVisible" width="30%">
      <div>
        <div>
          <span style="font-weight: bold;">您要导出此成绩单的姓名和学号的对应关系表吗？</span>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="exportStudentNumListDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="exportStudentNumListAction">立即导出</el-button>
      </span>
    </el-dialog>


    <el-dialog title="设置查询开始时间" :visible.sync="setStartSearchExamDialogVisible" width="30%">
      <div>
        <div>
          <span style="font-weight: bold;">查询开始时间为:</span>
          <el-date-picker v-model="start_search_time" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
            type="datetime">
          </el-date-picker>
        </div>

        <div style="color:red;font-size: 14px;margin-top: 20px;text-align: center;">注：未设置时间表示发布后即可查询.</div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="setStartSearchExamDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveStartSearchExamTime">保存设置</el-button>
      </span>
    </el-dialog>


    <el-dialog title="导出成功" :visible.sync="downloadExcelDialogVisible" width="30%">
      <div>
        <div>
          <div style="margin-bottom: 10px;">下载地址如下：</div>
          <div>{{full_excel_file_url}}</div>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="downloadExcelDialogVisible = false">取 消</el-button>
        <el-button type="default" @click="copyFileUrl()">复制下载网址</el-button>
        <el-button type="primary" @click="openFileUrl()">立即下载</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        dateList: ['全部'],
        filterCondition: '',
        students: [],
        username: '',
        tableData: [],
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        selectedExamID: '',
        msg: '',
        configurations: [],
        showPosition: false,
        unReadDialogFormVisible: false,

        shownotify: 0,
        successDialogVisible: false,

        showScoreAvg: false,
        showSection: false,
        showAvgTrend: false,
        unlockDialogVisible: false,
        unlockForm: {
          student_name: '',
          student_num: ''
        },

        img_url: '',

        setSearchStatedialogVisible: false,
        setSearchStateDialogTitle: '',
        setSearchStateBtn: '',
        setSearchStateInfo: '',

        total_record: 0,
        pageSize: 10,

        shareDocDialogVisible: false,
        collectAdviceDialogVisible: false,

        zeroHelpDialogVisible: false,
        selectedZeroExam: '',


        testQueryDialogVisible: false,

        exportStudentNumListDialogVisible: false,
        exportStudentNumListExamId: '',


        start_search_time: '',
        setStartSearchExamDialogVisible: false,

        downloadExcelDialogVisible: false,

        excel_file_url: '',
        full_excel_file_url: '',


        wansearchDialogVisible: false,
        checkingDialogVisible: false,
        evaluationsDialogVisible:false

      }
    },
    mounted() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.loadSetting()
    },
    created() {
      console.log('调用exam_list created')
      this.username = this.$session.get('USERNAME') // 获取session
      // this.username = this.$route.params.username

      // this.loadDateList()
      this.loadData()
    },
    methods: {
      loadDateList() { // 加载发布的日期
        console.log('参数：' + this.$route.params.shownotify)

        if (this.$route.params.shownotify === 1) {
          this.shownotify = 1
        } else {
          this.shownotify = 0
        }

        // this.dateList.length = 0
        let that = this
        var requestUrl = '/score/web/_load_exams.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            that.dateList = response.data
            // this.$forceUpdate()

            if (that.shownotify === 1) {
              that.shownotify = 0
              that.successDialogVisible = true
            }
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      loadData() {
        // console.log('加载数据')
        // let that = this

        // // 开启loading
        // const load = this.$loading({
        //   lock: true,
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // })

        // var requestUrl = '/score/web/_load_exams.jsp'
        // this.axios.get(requestUrl, {
        //     params: {
        //       username: that.username,
        //       filter_date: that.filterCondition
        //     }
        //   }).then(function(response) {
        //     that.tableData = response.data
        //     load.close()

        //     // 导出学生清单
        //     that.exportStudents()
        //   })
        //   .catch(function(error) {
        //     console.log(error)
        //     load.close()
        //   })this.handleCurrentChange(1)

        this.handleCurrentChange(1)
      },
      indexMethod() {
        this.index++
        return this.index
      },
      convertPaperScore(course, paperScore) {
        if (course === '总分' || course.indexOf('排名') >= 0) {
          return '/'
        } else {
          return paperScore
        }
      },
      viewExam(index, rows) {
        // rows.splice(index, 1);

        var examID = rows[index].id
        // var course = rows[index].course
        var exam = rows[index].exam

        console.log('查看成绩单:' + exam)

        this.$router.push({
          name: 'exam_detail',
          params: {
            id: examID,
            // course: course,
            exam: exam
          }
        })
      },
      delExam(index, rows) {
        this.position = index
        this.selectedExamID = rows[index].id

        this.msg = '确定要删除"' + rows[index].exam + '"成绩单吗?'

        this.dialogVisible = true
      },
      delExamRecord() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: '正在删除,请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        that.dialogVisible = false
        // 调用删除接口
        var requestUrl = '/score/web/_delete_exam_and_score.jsp'
        this.axios.get(requestUrl, {
            params: {
              id: that.selectedExamID
            }
          }).then(function(response) {
            // that.tableData.splice(that.position, 1)
            // that.loadDateList()
            that.loadData()

            that.dialogVisible = false
            load.close()
            that.$message.success('删除成功！')
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      openExamReport(index, rows){
        this.position = index
        this.selectedExamID = rows[index].id
        let that = this

        this.$router.push({
          name: 'exam_report',
          params: {
            id: that.selectedExamID
          }
        })
      },
      editExam(index, rows) {
        this.position = index
        this.selectedExamID = rows[index].id
        let that = this

        this.$router.push({
          name: 'exam_edit',
          params: {
            id: that.selectedExamID
          }
        })
      },
      importExcel() {
        this.$router.push('/exam_import')
      },
      importMutiExcel() {
        this.$router.push('/exam_import_anyfile')
      },
      createNewExam() {
        this.$router.push('/exam_new')
      },
      searchSettingExam(index, rows) {
        let that = this

        this.position = index
        this.selectedExamID = rows[index].id

        // 加载状态
        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 注册接口
        var requestUrl = '/score/web/_load_settings.jsp'
        this.axios.get(requestUrl).then(function(response) {
            console.log(response.data)

            that.configurations = response.data

            if (response.data === null || response.data.length === 0) {
              that.showPosition = false
              // console.log('************')
            } else {
              for (var i = 0; i < that.configurations.length; i++) {
                console.log(that.configurations[i])
                if (that.configurations[i].setting_name === 'show_position') {
                  console.log(that.configurations[i].setting_value)

                  if (that.configurations[i].setting_value === '1') {
                    that.showPosition = true
                  } else {
                    that.showPosition = false
                  }

                  break
                }
              }
            }

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })

        this.searchResultSettingDialogTableVisible = true
      },
      saveSettings() {
        let intShowScoreAvg = 0
        if (this.showScoreAvg === true) {
          intShowScoreAvg = 1
        }

        let intShowSection = 0
        if (this.showSection === true) {
          intShowSection = 1
        }

        let intShowAvgTrend = 0
        if (this.showAvgTrend === true) {
          intShowAvgTrend = 1
        }

        let that = this

        console.log(intShowScoreAvg + ':' + intShowSection + ':' + intShowAvgTrend)

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 注册接口
        var requestUrl = '/score/web/_update_show_setting.jsp'
        this.axios.get(requestUrl, {
            params: {
              intShowScoreAvg: intShowScoreAvg,
              intShowSection: intShowSection,
              intShowAvgTrend: intShowAvgTrend,
              username: that.username
            }
          }).then(function(response) {
            console.log(response.data.result)
            that.$message.success('参数设置成功！')
            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })

        this.searchResultSettingDialogTableVisible = false
      },

      indexMethods(index) {
        return this.tableData.length - index
      },
      viewUnSearchList(index, rows) {
        let that = this

        this.position = index
        this.selectedExamID = rows[index].id

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 注册接口
        var requestUrl = '/score/web/_get_students_score_list_unsearch.jsp'
        this.axios.get(requestUrl, {
            params: {
              id: that.selectedExamID
            }
          }).then(function(response) {
            that.students = response.data
            that.unReadDialogFormVisible = true

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      closeUnreadDialog() {
        this.unReadDialogFormVisible = false
      },
      filterExams(date) {
        console.log(date)
      },
      selectChanged() {
        console.log(this.filterCondition)
        this.loadData()
      },
      phoneShowSetting() {
        this.searchResultSettingDialogTableVisible = true
      },
      loadSetting() {
        let that = this
        var requestUrl = '/score/web/_load_settings.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            let list = response.data

            console.log(list)

            for (var i = 0; i < list.length; i++) {
              var settingName = list[i].setting_name
              var settingValue = list[i].setting_value

              console.log(settingName + '=' + settingValue)

              if (settingName === 'intShowScoreAvg') {
                if (settingValue === '1') {
                  that.showScoreAvg = true
                } else {
                  that.showScoreAvg = false
                }
              }

              if (settingName === 'intShowSection') {
                if (settingValue === '1') {
                  that.showSection = true
                } else {
                  that.showSection = false
                }
              }

              if (settingName === 'intShowAvgTrend') {
                if (settingValue === '1') {
                  that.showAvgTrend = true
                } else {
                  that.showAvgTrend = false
                }
              }
            }
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      closeSettings() {
        this.searchResultSettingDialogTableVisible = false
        this.loadSetting()
      },
      unlockPhone() {
        this.unlockDialogVisible = true
      },
      unlockAllPhone() {
        let that = this

        this.$confirm('确定要解锁所有手机(查询过您发布的成绩单)吗?', '操作提醒', {
          confirmButtonText: '全部解锁',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          var requestUrl = '/score/web/_unlock_all.jsp'
          this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            console.log(response)

            if (response.data.result === '1') {
              that.$message.success('解锁成功！！')
            } else {
              that.$message.error(response.data.message)
            }

            load.close()
          }).catch(function(error) {
            console.log(error)
            load.close()
          })
        }).catch(() => {

        })
      },
      importedNextStep() {
        this.successDialogVisible = true
      },
      unlock() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_unlock.jsp'
        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            student_name: that.unlockForm.student_name,
            student_num: that.unlockForm.student_num
          }
        }).then(function(response) {
          console.log(response)

          if (response.data.result === '1') {
            that.$message.success('解锁成功！！')
          } else {
            // that.$message.error(response.data.message)
            that.$alert(response.data.message)
          }

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })

        this.unlockDialogVisible = false
      },
      exportStudents() {
        let that = this

        var qrcodeRequestUrl = '/score/web/_qrcode.jsp'
        this.axios.get(qrcodeRequestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            let tmpFile = response.data.filename
            that.qrcode_img_url = '/score' + tmpFile
            console.log(this.qrcode_img_url)
          })
          .catch(function(error) {
            console.log(error)
          })

        var requestUrl = '/score/web/_export_students_to_excel.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            console.log(response.data)
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      convertPostion(index) {
        if (index === 0) {
          return '显示'
        } else {
          return '不显示'
        }
      },
      pointSetting(index, rows) {
        this.selectedExamID = rows[index].id
        var exam_name = rows[index].exam

        this.$router.push({
          name: 'point_setting',
          params: {
            id: this.selectedExamID,
            exam_name: exam_name
          }
        })
      },
      setSearchState(index, rows, state) {
        this.selectedExamID = rows[index].id

        if (state == 1) {
          this.setSearchStateInfo = '可查询'
          this.setSearchStateBtn = '关闭查询'
        } else {
          this.setSearchStateInfo = '不可查询'
          this.setSearchStateBtn = '修改'
          this.setSearchStateBtn = '打开查询'
        }

        this.setSearchStateDialogTitle = '修改查询状态'
        this.setSearchStatedialogVisible = true
      },
      updateSearchState() {
        var search_state = 1
        if (this.setSearchStateBtn == '关闭查询') {
          search_state = 0
        }

        let that = this

        var qrcodeRequestUrl = '/score/web/_update_search_state.jsp'
        this.axios.get(qrcodeRequestUrl, {
            params: {
              username: that.username,
              exam_key: that.selectedExamID,
              search_state: search_state
            }
          }).then(function(response) {
            that.setSearchStatedialogVisible = false
            that.loadData()
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      handleCurrentChange(currentPage) {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_load_exams.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              filter_date: that.filterCondition,
              current_page: currentPage,
              page_size: that.pageSize,
              condition: that.condition
            }
          }).then(function(response) {
            that.tableData = response.data.exams
            load.close()

            that.total_record = response.data.total_record

            // 导出学生清单
            that.exportStudents()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      viewCurrentExam(row, column, event) {
        // console.log(row, column)
        // this.viewExam(index, rows)

        var examID = row.id
        // var course = rows[index].course
        var exam = row.exam

        console.log('查看成绩单:' + exam)

        this.$router.push({
          name: 'exam_detail',
          params: {
            id: examID,
            // course: course,
            exam: exam
          }
        })
      },
      showShareDocDialog() {
        this.shareDocDialogVisible = true
      },
      showWanSearchDialog() {
        this.wansearchDialogVisible = true
      },
      showCheckingDialog(){
        this.checkingDialogVisible=true
      },showEvaluationsDialog(){
        this.evaluationsDialogVisible=true
      },
      publishNotice(index, rows) {
        var examID = rows[index].id

        this.$router.push({
          name: 'exam_edit_html',
          params: {
            exam_key: examID
          }
        })
      },
      exportStudentNumList(index, rows) {
        var examID = rows[index].id
        this.exportStudentNumListDialogVisible = true
        this.exportStudentNumListExamId = examID
      },
      exportStudentNumListAction() {
        let that = this

        this.exportStudentNumListDialogVisible = false

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_export_exam_students.jsp'
        this.axios.get(requestUrl, {
            params: {
              exam_id: this.exportStudentNumListExamId
            }
          }).then(function(response) {
            console.log(response.data)

            var url = '/score/temp/' + response.data.file_name
            that.excel_file_url = url

            var base_url = window.location.protocol + '//' + window.location.host
            that.full_excel_file_url = base_url + that.excel_file_url
            that.downloadExcelDialogVisible = true
            // window.open(url)

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      openFileUrl() {
        window.open(this.excel_file_url)
      },
      copyFileUrl() {
        const textToCopy = this.full_excel_file_url;
        const input = document.createElement("input");

        // 将字符串赋值给input元素的value属性
        input.value = textToCopy;

        // 将input元素添加到DOM中
        document.body.appendChild(input);

        // 选中input元素的文本内容
        input.select();

        // 复制文本内容到剪贴板
        document.execCommand("copy");

        // 删除input元素
        document.body.removeChild(input);

        // 给出复制成功的提示
        alert("下载地址已复制到剪贴板！");
      },
      collectAdvice(index, rows) {
        this.collectAdviceDialogVisible = true
      },
      showZeroHelp(selectedZeroExam) {
        this.selectedZeroExam = selectedZeroExam
        this.zeroHelpDialogVisible = true
      },
      setSearchTime(index, rows) {
        this.selectedExamID = rows[index].id
        var exam_name = rows[index].exam
        // console.log(exam_name,this.selectedExamID)
        this.setStartSearchExamDialogVisible = true
      },
      isPastTime(time) {
        // 获取当前时间的时间戳（毫秒）
        var currentTime = Date.now();

        // 将传入的时间参数转换为时间戳（毫秒）
        var specifiedTime = typeof time === 'object' ? time.getTime() : time;

        // 判断传入的时间是否小于当前时间
        if (specifiedTime < currentTime) {
          return true;
        } else {
          return false;
        }
      },
      saveStartSearchExamTime() {

        /*        if (this.start_search_time == '') {
                  this.$alert('请选择查询开始的时间!')
                  return
                } */

        var pastTime = new Date(this.start_search_time); // 指定时间对象
        //console.log(isPastTime(pastTime)); // 输出: true

        if (this.start_search_time != '' && this.isPastTime(pastTime)) {
          this.$alert(this.start_search_time + '是过去的时间,请重新选择!')
          return
        }



        // console.log('ssssssssssss',this.start_search_time)

        let that = this
        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        if (this.start_search_time != '') {
          console.log(this.start_search_time.length)
          if(this.start_search_time.length==16){
            this.start_search_time = that.start_search_time + ':00'
          }
        }

        var requestUrl = '/score/web/_update_search_start_time.jsp'
        this.axios.get(requestUrl, {
            params: {
              exam_key: that.selectedExamID,
              username: that.username,
              start_search_time: that.start_search_time
            }
          }).then(function(response) {
            console.log(response.data)


            load.close()

            that.loadData()

            that.$message('设置成功！')

            that.setStartSearchExamDialogVisible = false
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })



      },
      getStopSearchLabel(search_state, search_start_time) {
        var label = ''
        if (search_state == '0') {
          if (search_start_time == '') {
            label = '查询已关闭'
          } else {
            if (!this.isPastTime(search_start_time)) {
              label = '查询暂未开始'
            }
          }

        }

        return label
      },
      viewDetailReason(search_state, search_start_time) {
        if (search_state == '0') {
          if (search_start_time == '') {
            this.$alert('手工关闭了查询')
          } else {
            if (!this.isPastTime(search_start_time)) {
              this.$alert('开放查询时间还未到,开放时间为:' + search_start_time)
            }
          }

        }
      }


    },
    watch: {
      $route() {
        this.loadData()
      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #c8def9;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/components/exam_list.vue